import React, { Component } from "react";
import customFetch from "./apicall/api";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { logout, chkapiinput, checkTime, generateId } from "./Utility";
import { ThemeContext } from "../context/IsLoader";
const generate_Id1 = generateId(10);
class PaymentTransfer_Loan extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      isDisable: true,
      totalAmt: 0,
      payment_method: "C",
      remark: "",
      totsum: 0,
      isOpen: false,
      errorMsg: [],
      isDisableBtn: true,
      isErrOpen: false,
      api_error_message: "",
      isSpin: false,
      isOffline: false,
      isLogout: false,
      principle_os: 0,
      interest_os: 0,
      forclosure_charges: 0,
      Nach_bounce_charges: 0,
      penal_charges: 0,
      time_flag: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    if (checkTime() !== false) {
      this.state.time_flag = 1;
      this.setState({ isSpin: false, maintaenance: checkTime() });
    }
  }
  handleChange(event) {
    // if (event.target.name === "payment_method" && event.target.value === "U") {
    //   this.setState({ isUPI: true });
    // }
    if (event.target.name === "remark") {
      const pattern = /[^0-9a-zA-Z. ]/g;
      const result = pattern.test(event.target.value);
      //console.log("Email Valid:", result);
      if (result === false) {
        //this.setState({ errormsg: "", isEnable: false });
        this.setState({ remark: event.target.value });
      }
    } else {
      this.setState(
        {
          [event.target.name]: event.target.value.replace(/[^0-9.]/g, "") * 1,
        },
        function() {
          let principle_os = this.state.principle_os
            ? parseFloat(this.state.principle_os)
            : 0;
          let interest_os = this.state.interest_os
            ? parseFloat(this.state.interest_os)
            : 0;
          let forclosure_charges = this.state.forclosure_charges
            ? parseFloat(this.state.forclosure_charges)
            : 0;
          let Nach_bounce_charges = this.state.Nach_bounce_charges
            ? parseFloat(this.state.Nach_bounce_charges)
            : 0;
          let penal_charges = this.state.penal_charges
            ? parseFloat(this.state.penal_charges)
            : 0;
          let othamt =
            principle_os +
            interest_os +
            forclosure_charges +
            Nach_bounce_charges +
            penal_charges;
          //console.log("Total", othamt);
          this.setState({ totsum: othamt });
        }
      );
      //console.log("Else Part");
    }
    //this.updtotal();
  }

  handleSubmit(event) {
    //event.preventDefault();
    if (navigator.onLine) {
      this.setState({ isDisable: true, isDisableBtn: true, isSpin: true });
      const uid = localStorage.getItem("in_userid");
      if (!uid) {
        this.setState({ isLogout: true, isSpin: false, isOpen: false });
        return;
        // localStorage.clear();
        // this.props.history.push("/");
      }
      const { api_token, hh_id, loan_id, Borrower_Name } =
        (this.props.location && this.props.location.state) || {};
      if (uid) {
        /*Check if data is null then logout*/
        var arr = [
          this.state.principle_os,
          this.state.interest_os,
          this.state.forclosure_charges,
          this.state.Nach_bounce_charges,
          this.state.penal_charges,
          loan_id.split("~")[1],
          hh_id,
          uid,
          this.state.payment_method,
          this.state.remark,
        ];
        var chkdata = chkapiinput(arr);
        if (chkdata === false) {
          this.setState({ isSpin: false });
          setTimeout(function() {
            logout();
          }, 2000);
        }
        const formdata = new FormData();
        formdata.append("principle_os", this.state.principle_os);
        formdata.append("interest_os", this.state.interest_os);
        formdata.append("forclosure_charges", this.state.forclosure_charges);
        formdata.append("nach_bounce_charges", this.state.Nach_bounce_charges);
        formdata.append("penal_charges", this.state.penal_charges);
        formdata.append("loan_id", loan_id.split("~")[1]);
        formdata.append("household_id", hh_id);
        formdata.append("userid", uid);
        formdata.append("in_collection_mode_flag", this.state.payment_method);
        formdata.append("in_remark", this.state.remark);
        let generate_Id = generateId(10);
        const requestOptions = {
          method: "POST",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: localStorage.getItem("in_userid"),
          },
          body: formdata,
        };
        // for (const value of formdata.values()) {
        //   console.log(value);
        // }
        customFetch(
          process.env.REACT_APP_URL + "/set/collection/handle/foreclosure",
          requestOptions
        )
          .then((response) => {
            if (response.headers.get("api_code") > 0) {
              this.setState({
                isErrOpen: true,
                api_error_message: response.headers.get("api_error_message"),
                isSpin: false,
              });
            }
            return response.json();
          })
          .then((data) => {
            //console.log(data);
            if (
              data.api_code === 4 ||
              data.api_code === 3 ||
              data.api_code === 5
            ) {
              localStorage.clear();
              this.props.history.push("/");
            }
            if (data.timestamp) {
              this.props.history.push({
                pathname: "/collectionSuccess",
                state: {
                  api_token: api_token,
                  Household_name: Borrower_Name,
                  OcrAmount: this.state.totsum,
                  tmp_txn_ref_no: data.txn_detail,
                  tmp_timestamp: data.timestamp,
                  payment_method: this.state.payment_method,
                },
              });
            } else {
              this.setState({
                isErrOpen: true,
                api_error_message: data.message,
                isSpin: false,
              });
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        this.setState({
          isErrOpen: true,
          api_error_message: "Please Contact Helpdesk",
          isSpin: false,
        });
      }
    } else {
      this.setState({
        isOffline: true,
        isOpen: false,
        isSpin: false,
      });
    }
  }
  render() {
    const {
      api_token,
      od_amt,
      od_charge,
      cd_amt,
      hh_id,
      hh_no,
      Borrower_Name,
      loan_id,
    } = (this.props.location && this.props.location.state) || {};
    const {
      isOpen,
      errorMsg,
      isDisableBtn,
      isErrOpen,
      isUPI,
      api_error_message,
      isSpin,
      isOffline,
    } = this.state;
    console.log("Check Internet", navigator.onLine ? "online" : "offline");
    var loannumber = loan_id.split("~")[0];
    var loanid = loan_id.split("~")[1];
    return (
      <>
        {isSpin ? (
          <div class="preloader">
            <div class="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            this.state.isLogout
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => logout(null, null, true)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>We Have to Log You Out. Kindly Login again</p>
            </div>
          </div>
        </div>
        <div
          className={
            isOffline
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isOffline: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="modal-body">
                <p>Please Check Your Internet Connection</p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={() => window.location.reload(false)}
                >
                  Reload
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isErrOpen: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
            </div>
          </div>
        </div>
        <div
          className={
            isOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content pt-confirm-box col-sm-12">
              <span className="cb-cname">Name</span>

              <div className="cb-cname-box">{Borrower_Name}</div>

              <div className="emiCharge">
                <div>
                  <span className="cb-cname">Total Amount</span>
                  <div className="cb-cname-box">
                    {"Rs. " + this.state.totsum}

                    {/* Rs. {parseFloat(this.state.totsum)} */}
                  </div>
                  <div></div>
                </div>
              </div>

              <span className="cb-cname">Loan ID</span>

              <div className="cb-cname-box">{loannumber}</div>

              <div className="cb-buttons">
                <div className="col-sm-6">
                  <button
                    className="btn btn-primary btn-lg btn-block rbtn"
                    onClick={() => {
                      this.handleSubmit();
                    }}
                    disabled={!this.state.totsum}
                  >
                    Confirm
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.setState({ isOpen: false })}
                    className="btn btn-primary btn-lg btn-block rbtn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="header-area">
            <div
              className="icon_bg"
              onClick={() => this.props.history.goBack()}
            >
              <img
                src={require("../assets/images/back.png")}
                className="icon_img"
              />
            </div>

            <span className="head-title">Payment Transfer</span>
            {/* <a data-toggle="modal" data-target="#sort-filter">
                                <div className="icon_bg"><img src={require("../assets/images/page.png")} className="icon_img" /></div>
                            </a> */}
            <a>
              <div className="log-out-deposit">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout(null, null, true)}
                  alt=""
                />
              </div>
            </a>
          </div>
          {this.state.time_flag == 1 ? (
            <div className="maintaenance-container">
              <div className="maintaenance-image">
                <img src="data:image/gif;base64,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" />
              </div>
              <br />
              <div class="content">
                <h3>
                  <span className="maintaenance-text">
                    {" "}
                    Maintenance in progress.
                    <br />
                    <p>{this.state.maintaenance}</p>
                  </span>
                </h3>
                <p>Please stand by</p>
              </div>
            </div>
          ) : (
            <>
              <div className="payment-method-block">
                <div className="htext">
                  <span className="bluetext">Name: </span>
                  {Borrower_Name}
                </div>
                <div className="htext">
                  <span className="bluetext">Loan Id: </span>
                  {loannumber}
                </div>
                <div className="pthtext2">
                  <span className="bluetext">Principle os</span>
                </div>
                <div className="col-sm-12">
                  <input
                    type="text"
                    value={this.state.principle_os}
                    name="principle_os"
                    onChange={this.handleChange}
                    className="form-control rinput"
                  />
                  <span className="errmsg">{errorMsg.totalAmt}</span>
                </div>
                <div className="pthtext2">
                  <span className="bluetext">Interest os</span>
                </div>

                <div className="col-sm-12">
                  <input
                    type="text"
                    value={this.state.interest_os}
                    name="interest_os"
                    onChange={this.handleChange}
                    className="form-control rinput"
                  />
                  <span className="errmsg">{errorMsg.charges}</span>
                </div>
                <div className="pthtext2">
                  <span className="bluetext">Forclosure Charges</span>
                </div>

                <div className="col-sm-12">
                  <input
                    type="text"
                    value={this.state.forclosure_charges}
                    name="forclosure_charges"
                    onChange={this.handleChange}
                    className="form-control rinput"
                  />
                  <span className="errmsg">{errorMsg.charges}</span>
                </div>
                <div className="pthtext2">
                  <span className="bluetext">Nach Bounce Charges</span>
                </div>

                <div className="col-sm-12">
                  <input
                    type="text"
                    value={this.state.Nach_bounce_charges}
                    name="Nach_bounce_charges"
                    onChange={this.handleChange}
                    className="form-control rinput"
                  />
                  <span className="errmsg">{errorMsg.charges}</span>
                </div>
                <div className="pthtext2">
                  <span className="bluetext">Penal Charges</span>
                </div>

                <div className="col-sm-12">
                  <input
                    type="text"
                    value={this.state.penal_charges}
                    name="penal_charges"
                    onChange={this.handleChange}
                    className="form-control rinput"
                  />
                  <span className="errmsg">{errorMsg.charges}</span>
                </div>

                <div className="pthtext2">
                  <span className="bluetext">Remark</span>
                </div>

                <div className="col-sm-12">
                  <textarea
                    className="form-control rinput"
                    rows="2"
                    onChange={this.handleChange}
                    value={this.state.remark}
                    name="remark"
                  ></textarea>
                </div>

                <div className="pt_total_amt_block">
                  <div className="pt_tamt">
                    <span>Total Amount: </span>
                  </div>

                  <div className="pt_amt_block">
                    {"Rs. " +
                      parseFloat(this.state.totsum).toLocaleString("en-IN")}
                    {/* Rs. {parseFloat(this.state.totsum).toLocaleString("en-IN")} */}
                  </div>
                </div>
              </div>
              <div className="pt_button_block">
                <div className="col-6 col-lg-4">
                  <button
                    className="btn btn-primary btn-lg btn-block rbtn"
                    // data-toggle="modal"
                    // data-target="#confirm-box"
                    disabled={!this.state.remark || !this.state.totsum > 0}
                    onClick={() =>
                      this.setState({
                        isDisableBtn: false,
                        isOpen: true,
                      })
                    }
                  >
                    Save
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}
export default withRouter(PaymentTransfer_Loan);
